import { render, staticRenderFns } from "./pricing2.vue?vue&type=template&id=61f539df&"
import script from "./pricing2.vue?vue&type=script&lang=js&"
export * from "./pricing2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports